import { render, staticRenderFns } from "./SparePartGrid.vue?vue&type=template&id=0b8d2a7e"
import script from "./SparePartGrid.vue?vue&type=script&lang=ts"
export * from "./SparePartGrid.vue?vue&type=script&lang=ts"
import style0 from "./SparePartGrid.vue?vue&type=style&index=0&id=0b8d2a7e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports